import { Typography, styled } from '@mui/material'

export const StyledTitle = styled(Typography)(({ theme }) => ({
  // fontSize: theme.typography.pxToRem(24),
  // fontWeight: 700,
  // color: theme.palette.text.primary,
  textAlign: 'center',
  marginTop: 8,
}))

export const StyledCloseButton = styled('span')(({ theme }) => ({
  position: 'absolute',
  backgroundColor: theme.palette.lightGreen.main,
  padding: '6px 7px',
  right: 10,
  top: 10,
  color: 'red',
  border: 'none',
  cursor: 'pointer',
  borderRadius: 8,
  '&:hover': {
    backgroundColor: theme.palette.lightGreen.hover,
  },
}))
